export const isSummary = (pathname) => {
    const path = pathname.split('/');
    return path[2] === 'summary';
};